var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "lock-thin_svg__Ebene_1",
  x: 0,
  y: 0,
  viewBox: "0 0 35.5 40.5"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".lock-thin_svg__st0{fill:#df0000}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "lock-thin_svg__modules"
}, /*#__PURE__*/React.createElement("g", {
  id: "lock-thin_svg__mm_x5F_internet_x5F_dankeseite_x5F_1_x26_1_x5F_L"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.2 15h-21v-4.8c0-4.7 3.8-8.5 8.5-8.5 3.8 0 7.2 2.6 8.2 6.2 0 .2.2.4.4.5s.4.1.7.1c.2 0 .4-.2.5-.4s.2-.4.1-.7C26.4 3 22.3-.1 17.7-.1 12-.1 7.5 4.5 7.5 10.1v4.8H5.3c-2.9 0-5.2 2.4-5.2 5.2v15c0 2.9 2.3 5.2 5.2 5.2h25c2.9 0 5.2-2.4 5.2-5.2v-15c0-2.7-2.4-5.1-5.3-5.1m0 23.8h-25c-1.9 0-3.5-1.6-3.5-3.5v-15c0-1.9 1.6-3.5 3.5-3.5h25c1.9 0 3.5 1.6 3.5 3.5v15c.1 1.9-1.5 3.5-3.5 3.5",
  className: "lock-thin_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2 25h-5c-1.5 0-2.8 1.2-2.8 2.8s1.2 2.8 2.8 2.8h5c1.5 0 2.8-1.2 2.8-2.8S21.8 25 20.2 25m0 3.8h-5c-.5 0-1-.4-1-1s.5-1 1-1h5c.5 0 1 .4 1 1s-.4 1-1 1",
  className: "lock-thin_svg__st0"
})))));
export default SvgLockThin;